import React, { useEffect } from "react";
import { Link } from "react-router-dom"
import styles from "./ProtectedLayout.module.scss";
import "./Alert.css"
import Navbar from "./Navbar";


import { Layout } from 'antd';
import { confirmAlert } from 'react-confirm-alert';

/**Import Assets */
import logo from "./images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { updateKey } from "../../features/DefaultReducer";
import link1 from "./images/1.svg";
import link2 from "./images/2.svg";
import link3 from "./images/3.svg";
import link4 from "./images/4.svg";
import link5 from "./images/5.svg";
import link6 from "./images/6.svg";
import link7 from "./images/7.svg";
import link8 from "./images/8.svg";
import link9 from "./images/9.svg";
import link10 from "./images/10.svg";
import post from "./images/post.svg";
import donate from "./images/donate.svg";
import notification from "./images/noti.svg";
import edit from "./images/edit.svg";
import report_post from "./images/report_post.svg";



import { resetState as profileReset } from "../../features/ProfileReducer";
import { resetState as reportReset } from "../../features/ReportManagementReducer";
import { resetState as soundTracksReset } from "../../features/SoundTracksReducer";
import { resetState as textReset } from "../../features/StaticTextReducer";
import { resetState as subscriptionReset } from "../../features/SubscriptionReducer";
import { resetState as userReset } from "../../features/UserManagementReducer";
import { resetState as cashOutReset } from "../../features/CashOutReducer";
import { resetState as constantReset } from "../../features/ConstantReducer";
import { resetState as dashboardReset } from "../../features/DashboardReducer";
import { resetState as postReset } from "../../features/PostManagementReducer";
import { resetValue as searchReset } from "../../features/SearchReducer";
import { fetchInboxIndicatorThunk, resetState as inboxReset } from "../../features/InboxReducer";
import AlertModal from "../Modal/AlertModal";

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from "antd";
const antIcon = <LoadingOutlined style={{ fontSize: 15, color: "white" }} spin />;

const { Sider } = Layout;

export default function ProtectedLayout({ selectedRoute, isSearchBar, children }) {

    const dispatch = useDispatch();
    const { linkDisabled } = useSelector(state => state.default)
    const { inbox } = useSelector(state => state.inbox)
    const items = [
        {
            icon: link1,
            label: "Dashboard",
        },
        {
            icon: link2,
            label: "User Management",
        },
        {
            icon: post,
            label: "Post Management",
        },
        {
            icon: link5,
            label: "Reported Users",
        },

        {
            icon: report_post,
            label: "Reported Posts",
        },
        {
            icon: link3,
            label: "User Sound Tracks",
        },
        {
            icon: link3,
            label: "Upload Sound Tracks",
        },
        {
            icon: link6,
            label: "Subscription",
        },
        {
            icon: link4,
            label: "Cash Out Requests",
        },
        {
            icon: donate,
            label: "Donate History",
        },
        {
            icon: edit,
            label: "Coin Setup",
        },
        {
            icon: notification,
            label: "Notifications",
        },
        {
            icon: link7,
            label: "Terms And Conditions",
        },
        {
            icon: link8,
            label: "Privacy Policy",
        },
        {
            icon: link9,
            label: "FAQs",
        },
        {
            icon: edit,
            label: "Change Password",
        },
        {
            icon: notification,
            label: "Inbox",
            component: inbox.status === 'pending' ?
                <Spin indicator={antIcon} size="large" className={styles.indicatorSpinner} />
                : inbox.is_indicator ? <span className={styles.indicator}></span> : ''
        },

    ]

    useEffect(() => {
        if (inbox.status !== 'success') {
            dispatch(fetchInboxIndicatorThunk())
        }
    }, [])


    function handleLogout() {
        dispatch(updateKey({ isLoggedIn: false }));
        dispatch(profileReset());
        dispatch(reportReset());
        dispatch(soundTracksReset())
        dispatch(textReset())
        dispatch(subscriptionReset())
        dispatch(userReset())
        dispatch(cashOutReset())
        dispatch(constantReset())
        dispatch(dashboardReset())
        dispatch(postReset())
        dispatch(searchReset())
        dispatch(inboxReset())
        localStorage.removeItem("web_token")

    }

    function submit(title, message, cb, rejectCB = () => { }) {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <AlertModal
                        text={message}
                        handleClose={onClose}
                        handleDelete={() => {
                            cb();
                            onClose();
                        }}

                    />
                );
            },
            overlayClassName: "confirm-alert-background-change"
        });
    }



    return (
        <div className={styles.protectedLayout}>
            <Sider trigger={null} style={{ height: "100vh" }} className={styles.sider} width={270} >
                <div className={styles.children}>

                    <Link className={styles.logo} to={`/dashboard`}>
                        <img src={logo} alt="Logo Image" />

                    </Link>
                    <div className={styles.menu}>
                        {items.map(({ icon, label, component }, index) => {
                            return <Link
                                to={`/${label.toLowerCase().replace(/[^A-Z0-9]/ig, "-")}`}
                                className={`${styles.item} ${index == selectedRoute ? styles.active : ""}`}
                                key={index}
                                onClick={e => linkDisabled && e.preventDefault()}
                            >
                                <img src={icon} alt={`Icon${index}`} width={20} height={20} />
                                <p>{label}</p>
                                {component ? component : ""}
                            </Link>
                        })}
                        <Link
                            className={styles.item}
                            onClick={(e) => linkDisabled ? e.preventDefault() : submit("Confirm Logout", "Are you sure you want to logout?", () => handleLogout())} >
                            <img src={link10} alt="Icon1" width={20} height={20} />
                            <p>Logout</p>
                        </Link>

                    </div>

                </div>


            </Sider >
            <div className={styles.routeContent}>
                <Navbar isSearchBar={isSearchBar} />
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div >
    )
}